import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ClientInvoicesComponent from "./ClientInvoicesComponent";
import ClientPaymentComponent from "./ClientPaymentComponent";
import FsSupportHoursClaimsComponent from "./FsSupportClaimsComponent";

const BillingComponent = () => {
  const navigate = useNavigate();
  const { tab } = useParams();

  const containerRef = useRef(null);

  const tabNames = {
    timesheets: "TimeSheets",
    invoices: "Invoices",
    payments: "Payments",
  };

  const tabComponents = {
    timesheets: <FsSupportHoursClaimsComponent />,
    invoices: <ClientInvoicesComponent />,
    payments: <ClientPaymentComponent />,
  };

  const [activeTab, setActiveTab] = useState(tab || "timesheets");

  useEffect(() => {
    setActiveTab(tab || "timesheets");
  }, [tab]);

  const handleTabClick = (key) => {
    navigate(`/account/fs-dashboard/timesheets-billing/${key}`);
    setActiveTab(key);
  };

  return (
    <div className="post-jobs-container">
      <div className="post-jobs-tabs">
        <div className="tabs-group">
          <div className="tabs">
            {Object.entries(tabComponents).map(([key, component]) => (
              <div
                key={key}
                className={`tab ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                {tabNames[key]}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="post-job-tab-content">{tabComponents[activeTab]}</div>
    </div>
  );
};

export default BillingComponent;
